export default {
    saved (component, item) {
        component.$emit("saved", item);
    },

    validated (component, item) {
        component.$emit("validated", item);
    },

    selected (component, item) {
        component.$emit("selected", item);
    },

    initialized (component, item) {
        component.$emit("initialized", item);
    },
}